module.exports = __webpack_public_path__ + "img/fenlei.4b90fa31.png";